var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChainbnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.646 54.9936V61.6099L34.9185 65L29.354 61.6099V54.9936L34.9185 58.3837L40.646 54.9936ZM10 32.1099L15.5646 35.5V46.8463L25.1466 52.6149V59.2314L10 50.2364V32.1099ZM59.837 32.1099V50.2638L44.5277 59.2586V52.6423L54.1097 46.8735V35.5274L59.837 32.1099ZM44.5005 23.1149L50.228 26.505V33.1215L40.646 38.8901V50.4003L35.0815 53.7906L29.5439 50.4003V38.8629L19.6091 33.0941V26.4778L25.3366 23.0876L34.9185 28.8563L44.5005 23.1149ZM19.6091 37.8513L25.1737 41.2414V47.8577L19.6091 44.4676V37.8513ZM50.228 37.8513V44.4676L44.6635 47.8577V41.2414L50.228 37.8513ZM15.5646 17.3462L21.2921 20.7363L15.5646 24.1265V30.7428L10 27.3527V20.7363L15.5646 17.3462ZM54.2725 17.3462L60 20.7363V27.3527L54.2725 30.7428V24.1265L48.708 20.7363L54.2725 17.3462ZM34.9185 17.3462L40.646 20.7363L34.9185 24.1265L29.354 20.7363L34.9185 17.3462ZM34.9185 6L50.228 14.9949L44.6635 18.3851L35.0815 12.6163L25.3095 18.3851L19.7448 14.9949L34.9185 6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainbnb);
export default __webpack_public_path__ + "static/media/chainbnb.a7eade13.svg";
export { ForwardRef as ReactComponent };